<template>
  <div class="container">
    <a-spin size="large" :spinning="loading" tip="正在加载数据中，请等待">
      <a-tabs :activeKey="activeKey" class="moving-main-tab" :animated="false" @change="changeTab">
        <a-tab-pane key="selectGoods" tab="货品中心">
          <SelectGoods @move-preview="movePreview" @changeTab="(tab) => (activeKey = tab)" />
        </a-tab-pane>
        <a-tab-pane key="home" tab="链接铺货">
          <Home ref="home" @move-preview="movePreview" />
        </a-tab-pane>
        <a-tab-pane key="searchImage" tab="以图搜款">
          <SearchImage ref="searchImage" @move-preview="movePreview" />
        </a-tab-pane>
        <a-tab-pane key="preview" tab="铺货预览" forceRender>
          <ShippingPreviewList ref="shippingPreviewList" :activeKey="activeKey" @open-log-page="openLogPage" />
        </a-tab-pane>
        <a-tab-pane key="moveList" tab="上货列表">
          <OperateLogTable ref="operateLogTable" @move-preview="movePreview" />
        </a-tab-pane>
        <a-tab-pane
          key="https://saas.isaas.com/?productId=sas-230710JsMxnatNEm4juH95Ftg4A9#/dmOnlinemall/merchant/workbench"
          tab="前往店铺后台"
        ></a-tab-pane>
        <a-tab-pane key="https://b.alipay.com/page/home" tab="前往支付宝商家后台"></a-tab-pane>
      </a-tabs>
    </a-spin>
    <a-modal
      class="move-log-modal"
      v-model:visible="isShowLogModal"
      width="910px"
      style="top: 35px"
      :maskClosable="false"
    >
      <template #title>
        <div style="margin-bottom: 3px">获取商品数据日志</div>
        <MoveSteps :current="0" />
      </template>
      <LogModal ref="logModal" strType="p" />
      <template #footer>
        <a-button
          :loading="loading"
          type="primary"
          style="width: 280px; font-size: 16px; line-height: initial"
          @click="openPreviewPage"
        >
          打开铺货预览列表
        </a-button>
      </template>
    </a-modal>
    <MallLimitationModal ref="MallLimitationModal"></MallLimitationModal>
    <AuthTaoteModal ref="authTaoteModal" />
  </div>
</template>
<script>
// 选品中心
import SelectGoods from "./views/select_goods";
// 链接铺货
import Home from "./views/home";
// 铺货预览
import ShippingPreviewList from "./views/shipping_preview_list";
// 以图搜款
import SearchImage from "./views/search_image";
// 上货列表
import OperateLogTable from "./views/operate_log_table";
// 上面是页面, 下面是组件
// 淘特授权-弹出框
import AuthTaoteModal from "./components/auth_taote_modal";
// 铺货步骤条
import MoveSteps from "./components/move_steps";
// 操作日志弹出框
import LogModal from "@/views/base/components/log_modal/log_modal";
//账户多店铺限制
import MallLimitationModal from "@/views/base/components/mall_limitation_modal";
import handler from "./handler";
const refObj = { moveList: "operateLogTable", auditRecords: "auditRecordsTable" };
export default {
  components: {
    MoveSteps,
    Home,
    AuthTaoteModal,
    OperateLogTable,
    LogModal,
    ShippingPreviewList,
    SelectGoods,
    SearchImage,
    MallLimitationModal,
  },
  data() {
    return {
      activeKey: "selectGoods", // 默认是展示选品中心页面
      isShowLogModal: false, // 控制日志弹出框显隐
      loading: false, // 页面加载
      timer: null, // 定时器, 因为获取商品数据的操作是异步的, 需要监听获取商品数据量
    };
  },
  methods: {
    // 切换Tab菜单时触发
    changeTab(val) {
      if (val.includes("http")) return window.open(val);
      this.activeKey = val;
      const key = refObj[val];
      setTimeout(() => key && this.$refs[key].getData());
    },
    // 打开上货列表
    openLogPage() {
      this.changeTab("moveList");
    },
    // 链接铺货页里点击【铺货预览】时 || 选品中心页里点击【铺货预览】|| 上货列表里点击【铺货预览】 执行
    movePreview(obj) {
      handler.MovePreview(this, obj);
    },
    // 点击【打开铺货预览列表】切换到铺货预览页面
    openPreviewPage() {
      this.$message.loading("正在加载数据中，请耐心等待");
      clearInterval(this.timer);
      this.loading = true;
      this.changeTab("preview");
      setTimeout(() => (this.isShowLogModal = this.loading = false), 50);
    },
    // 删除本地保存的已铺货成功的商品id (map形式)
    removeSessionStorage() {
      sessionStorage.removeItem("pdd_xiaofeng_shanghuo_is_moved_success_ids");
    },
  },
  watch: {
    isShowLogModal(val) {
      if (!val) {
        this.loading = false;
        clearInterval(this.timer);
      }
    },
  },
  mounted() {
    window.addEventListener("beforeunload", this.removeSessionStorage);
  },
  unmounted() {
    window.removeEventListener("beforeunload", this.removeSessionStorage);
  },
};
</script>
<style scoped lang="less">
@import "./index";
</style>
<style lang="less">
@import "./index2";
</style>
